<template>
  <page-content
    no-top-content
    full-scroll-height
  >
    <slot name="breadcrumbs">
      <tm-breadcrumbs-wrapper
        v-if="breadcrumbs"
        :without-padding="true"
        class="mb-5"
      >
        <tm-breadcrumbs :breadcrumbs="breadcrumbs" />
      </tm-breadcrumbs-wrapper>
    </slot>

    <slot />
  </page-content>
</template>

<script setup lang="ts">
import type { Breadcrumbs } from '@/components/shared/types'
import PageContent from '@/components/layout/pageContent/PageContent.vue'
import TmBreadcrumbs from '@/components/shared/TmBreadcrumbs.vue'
import TmBreadcrumbsWrapper from '@/components/shared/TmBreadcrumbsWrapper.vue'

defineProps<{
  breadcrumbs?: Breadcrumbs
}>()
</script>
